<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import {
    playerState,
    updatePreviewEvent,
} from "@app/store/playerStore.svelte.js";
import { lockState } from "@app/store/lockStore.svelte.js";
import * as m from '@app/paraglide/messages.js';
import { styleState } from "@app/store/styleStore.svelte.js";
import convertToPlainText from "@cclib/functions/quill/convertToPlainText.js";
import throttle from "just-throttle";

/* Segment duration is the value used to segment the Events in the Event Group. */
const SEGMENT_DURATION = 60;
let previewEventWrapper = $state([]),
    nextEvent = $state();

const getEvent = throttle(
    () => {
        if (playerState.playing) {
            updatePreviewEvent(getEventByTime(playerState.time));
            if (playerState.previewEvent !== -1) {
                nextEvent = eventGroupState[projectState.selected].events.find(
                    (event) => {
                        return event.start > playerState.time;
                    },
                );
            } /* Scroll to and select the event if caption lock is enabled */
            if (
                lockState.caption &&
                playerState.previewEvent !== -1 &&
                eventGroupState[projectState.selected].selected[0] !==
                    playerState.previewEvent
            ) {
                eventGroupState[projectState.selected].selected = [
                    playerState.previewEvent,
                ];

                const selectedIndex =
                    eventGroupState[projectState.selected].selected[0];

                // Dispatch custom event to scroll to the selected event
                window.dispatchEvent(
                    new CustomEvent("scrollToVirtualListItem", {
                        detail: { index: selectedIndex },
                    }),
                );
            } else if (lockState.caption && playerState.previewEvent !== -1) {
                const selectedIndex =
                    eventGroupState[projectState.selected].selected[0];

                // Dispatch custom event to scroll to the selected event
                window.dispatchEvent(
                    new CustomEvent("scrollToVirtualListItem", {
                        detail: { index: selectedIndex },
                    }),
                );
            }
        } else {
            updatePreviewEvent(
                eventGroupState[projectState.selected]?.selected[0],
            );
        }
    },
    150,
    { leading: true },
);

function getEventByTime(sec) {
    return eventGroupState[projectState.selected].events.findIndex((event) => {
        return event.start <= sec && event.end >= sec;
    });
}

function decToHex(value) {
    return Math.floor((value / 100) * 255)
        .toString(16)
        .padStart(2, "0");
}

$effect(() => {
    // console.log("EFFECT Syncing previewEventWrapper with events...");
    getEvent(
        playerState.time,
        eventGroupState[projectState.selected]?.selected[0],
    );
});
</script>

{#if lockState.preview}
    <div
        id="SubtitlePreviewWrapper"
        class="d-flex justify-content-center align-items-start">
        <div
            id="SubtitlePreview"
            role="region"
            aria-live="polite"
            aria-label={m.player_adr_preview_aria_label()}>
            {#if eventGroupState[projectState.selected]}
                {#each eventGroupState[projectState.selected].events as previewEvent, evIndex (evIndex)}
                    {#if previewEvent.start && previewEvent.end && previewEvent.start > playerState.time - SEGMENT_DURATION && previewEvent.start < playerState.time + SEGMENT_DURATION}
                        <div
                            class="preview-event-wrapper"
                            bind:this={previewEventWrapper[evIndex]}
                            style="padding:0px; direction: {eventGroupState[
                                projectState.selected
                            ].rtl
                                ? 'rtl'
                                : 'ltr'}; 
                                font-family: {styleState.ccMode
                                ? eventGroupState[projectState.selected]
                                      ?.fontFamily
                                : styleState.fontFamily}; font-size: {styleState.adrFontSize ||
                                24}px;
                                color: {styleState.ccMode
                                ? '#ffffff'
                                : styleState.color +
                                  decToHex(styleState.opacity)};
                                background: {styleState.ccMode
                                ? '#000000'
                                : styleState.outlineColor};
                                {styleState.borderStyle == '1' &&
                            !styleState.ccMode
                                ? `text-shadow: ${styleState.shadow}px ${styleState.shadow}px 3px ${styleState.shadowColor + decToHex(styleState.shadowOpacity)}; 
      -webkit-text-stroke: ${styleState.outline}px ${styleState.outlineColor + decToHex(styleState.outlineOpacity)};
      background: none;`
                                : !styleState.ccMode
                                  ? `background: ${styleState.outlineColor + decToHex(styleState.outlineOpacity)};`
                                  : ''};
                                left: {(
                                (previewEvent.start - playerState.time) /
                                (previewEvent.end - previewEvent.start)
                            ).toFixed(2) *
                                (previewEventWrapper[evIndex]
                                    ? previewEventWrapper[evIndex].clientWidth
                                    : 100)}px;
                                top: {(evIndex % 2) *
                                styleState.adrFontSize *
                                1.7 +
                                3}px">
                            {convertToPlainText(previewEvent.text, " ")}
                        </div>
                    {/if}
                {/each}
            {/if}
        </div>
        <div
            id="center-line"
            style="height: {2 * styleState.adrFontSize * 1.7 + 3}px;">
        </div>
        {#if true}
            <div
                id="countdown-clock"
                style="height: 3px; width: {Math.max(
                    0,
                    (
                        (nextEvent ? nextEvent.start : 0) - playerState.time
                    ).toFixed(2) * 100,
                )}px;">
            </div>
        {/if}
    </div>
{/if}

<style>
#SubtitlePreviewWrapper {
    z-index: 9999;
    position: absolute;
    pointer-events: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
    top: 0;
}

#SubtitlePreview {
    position: absolute;
    left: 50%;
    margin-left: -3px;
    user-select: none;
    text-wrap: nowrap;
}

.preview-event-wrapper {
    position: absolute;
    will-change: transform, left;
    transition: left 250ms linear;
}

#center-line {
    border-left: 2px solid #ff000096;
    position: absolute;
    left: 50%;
    top: 0;
}

#countdown-clock {
    background-color: red;
    position: absolute;
    will-change: width;
    left: 50%;
    transition: width 0.25s linear;
}
</style>
